import { render } from "./RegistrationProfession.vue?vue&type=template&id=3a56ddb2&scoped=true&ts=true"
import script from "./RegistrationProfession.vue?vue&type=script&lang=ts"
export * from "./RegistrationProfession.vue?vue&type=script&lang=ts"

import "./RegistrationProfession.vue?vue&type=style&index=0&id=3a56ddb2&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a56ddb2"]])

export default __exports__